var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationPointerFull = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 70,
  height: 84,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h35.294v49.412H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(14)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  strokeOpacity: 0.25,
  stroke: "#6467EF",
  strokeWidth: 14,
  fillOpacity: 0.45,
  fill: "#6467EF",
  cx: 20.588,
  cy: 49.412,
  r: 27.588
}), /*#__PURE__*/React.createElement("circle", {
  strokeOpacity: 0.92,
  stroke: "#6467EF",
  strokeWidth: 3,
  fill: "#6467EF",
  cx: 20.588,
  cy: 48.382,
  r: 4.676
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.088)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.614 23.453c3.453.043 6.287-2.684 6.324-6.084.037-3.414-2.717-6.2-6.165-6.238-3.534-.038-6.352 2.622-6.414 6.054-.061 3.453 2.703 6.224 6.255 6.268m-3.003 22.406c-4.22-5.155-8.09-10.542-11.086-16.486C2.032 26.41.822 23.348.245 20.067-1.023 12.853 2.718 5.43 9.375 2.018c10.54-5.403 23.244.535 25.596 11.971.685 3.323.222 6.558-.835 9.742-1.485 4.47-3.77 8.552-6.338 12.493-2.96 4.544-6.285 8.823-9.895 12.89-.064.073-.133.142-.282.298-1.03-1.214-2.041-2.367-3.01-3.553z",
  fill: "#6467EF",
  mask: "url(#b)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationPointerFull);
export default ForwardRef;